module.exports =
  '_DASHBOARD':
    'TITLE': 'ダッシュボード'
    'HISTORY':
      'TOTAL_ROUNDS': '総ラウンド'
      'BEST_SCORE': 'ベストスコア'
      'AVERAGE_SCORE': '平均スコア'
      'SCORE': 'スコア'
      'FAIRWAY_HIT': 'フェアウェイキープ'
      'GIR': 'パーオン'
      'BOGEY_ON': 'ボギーオン率'
    'PERIOD_FILTER':
      'TARGET_RANGE': '対象期間'
      'TARGET_ROUND': '対象ラウンド'
      'INCLUDE_1_5': '1.5ラウンドを含める'
      'EXCLUDE_1_5': '1.5ラウンドを含めない'
      'INCLUDE_0_5': '0.5ラウンドを含める'
      'EXCLUDE_0_5': '0.5ラウンドを含まない'
      'INCLUDE_1_5_SP': '1.5 R を含める'
      'EXCLUDE_1_5_SP': '1.5 R を含めない'
      'INCLUDE_0_5_SP': '0.5 R を含める'
      'EXCLUDE_0_5_SP': '0.5 R を含まない'
    'BEST_SCORE': "ベストスコア"
    'FAVORITE_COURSE': "よく行くコース"
    'FAIRWAY_KEEP_COURSE': "FW キープコース"
    'RANKING': "ランキング"
    'MESSAGES':
      'M0001': 'この操作は現在ログインしているユーザでは実行できません。ログアウトしてから再度お試し下さい'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/dashboard/i18n/ja.coffee